module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "faces"
    }
  }, [(_vm.isLoggedIn) ? _c('div', [_c('div', {
    staticClass: "inline fields",
    attrs: {
      "id": "search"
    }
  }, [_c('div', {
    staticClass: "ui large label"
  }, [_vm._v("Filter: ")]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtertext),
      expression: "filtertext"
    }],
    attrs: {
      "id": "searchbox",
      "type": "text",
      "placeholder": "e.g. Joe Smith"
    },
    domProps: {
      "value": (_vm.filtertext)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filtertext = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.filteredFaces && _vm.filteredFaces.length) ? _c('div', {
    staticClass: "faces-list"
  }, _vm._l((_vm.filteredFaces), function(face) {
    return _c('div', {
      key: face.frontend_face_uuid,
      staticClass: "faces-list-entry"
    }, [_c('div', {
      staticClass: "faces-list-entry-info"
    }, [_c('div', {
      staticClass: "person-title"
    }, [_vm._v(_vm._s(face.person_name))]), _vm._v(" "), (face.employee) ? _c('div', [_c('strong', [_vm._v("Employee")])]) : _vm._e(), _vm._v(" "), (face.resident) ? _c('div', [_c('strong', [_vm._v("Resident")])]) : _vm._e(), _vm._v(" "), (face.wing || face.room) ? _c('div', [_c('strong', [_vm._v("Wing/Room:")]), _vm._v(" " + _vm._s(face.wing ? face.wing + ', ' : '') + "Room " + _vm._s(face.room) + "\n          ")]) : _vm._e(), _vm._v(" "), (face.wanderguard) ? _c('div', [_c('strong', [_vm._v("WanderGuard:")]), _vm._v("\n            " + _vm._s(face.wanderguard) + "\n          ")]) : _vm._e(), _vm._v(" "), (face.images_tagged) ? _c('router-link', {
      attrs: {
        "to": '/confirmed/' + face.frontend_face_uuid
      }
    }, [_vm._v("\n            " + _vm._s(face.images_tagged) + " image" + _vm._s(face.images_tagged > 1 ? 's' : '') + " tagged\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "search"
    }, [_c('router-link', {
      staticClass: "ui button small",
      attrs: {
        "to": '/detected/' + face.frontend_face_uuid
      }
    }, [_vm._v("Search")])], 1)], 1), _vm._v(" "), (face.images && face.images.length) ? _c('div', {
      staticClass: "face-image-area"
    }, _vm._l((face.images), function(image) {
      return _c('div', {
        key: image.thumbnail_uri,
        staticClass: "face-image-div"
      }, [_c('img', {
        directives: [{
          name: "lazy",
          rawName: "v-lazy",
          value: (image.thumbnail_uri),
          expression: "image.thumbnail_uri"
        }],
        staticClass: "face-image",
        attrs: {
          "height": "160px"
        }
      }), _vm._v(" "), _c('br'), _vm._v("\n            " + _vm._s(image.orientation) + "\n          ")])
    })) : _vm._e()])
  })) : _vm._e()]) : _c('div', [_vm._v("\n    To start, please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("log in")]), _vm._v(".\n  ")], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-296bf056","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Faces.vue
// module id = 297
// module chunks = 1